export default {
  //全局字典項
  logout: "退出",
  userCode: "用戶名",
  group: "集團",
  hotelGroupName: "集團名稱",
  hotelName: "酒店名稱",
  bizDate: "營業日期",
  code: "用戶名",
  name: "姓名",
  sex: "性別",
  roles: "崗位",
  mobile: "手機",
  createDatetime: "創建時間",
  modifyDatetime: "最後登錄時間",
  lastLoginDate: "上次登錄時間",
  lastIp: "上次登錄IP",
  mac: "設備唯一碼",
  view: "查看",
  more: "更多",
  add: "新增",
  delete: "刪除",
  search: "搜索",
  cancel: "取消",
  exit: "退出",
  determine: "確定",
  selectAll: "全選",
  fliter: "篩選",
  complete: "完成",
  share: "分享",
  refresh: "刷新",
  home: "首頁",
  all: "全部",
  other: "其他",
  multi_select: "多選",
  edit: "編輯",
  Copy: "複製",
  CopySuccess: "複製成功",
  myApp: "我的應用",
  operate: "操作",
  reset: "重置",
  empty: '清空',
  maintenance: "維修",
  lock: "鎖定",
  reservation: "預定",
  back: "返回",
  remark: "備注",
  success: "成功",
  reason: "原因",
  nothing: "什麼都沒有",
  senior: "高級",
  search: "查詢",
  list: "列表",
  gantt_chart: "甘特圖",
  site: "場地",
  modify: "修改",
  shutDown: "關閉",
  hotel: "酒店",
  save: "保存",
  morning: "上午",
  afternoon: "下午",
  evening: "晚上",
  Sunday: "周日",
  Monday: "周一",
  Tuesday: "周二",
  Wednesday: "周三",
  Thursday: "周四",
  Friday: "周五",
  Saturday: "周六",
  thisYear: "今年",
  lastYear: "去年",
  hundredmillion: "億",
  tenThousand: "萬",
  month: "月",
  placeHolder_Empty: "可空",
  sum: "共",
  bi: "筆",
  loading_end_message: "—— 　我是有底線的　 ——",
  sexDesc: "性別",
  sexMale: "男",
  sexFemale: "女",
  status: "狀態",
  clear: '清除',
  prderDetail_opera_num: '數量',
  prderDetail_no_data: '無記錄',
  prderDetail_opera_fee_type: '費用類型',
  prderDetail_opera_notice: '費用類型只顯示OHotel已經配置類型',

  book_no_ratecode: '無此類房價碼',

  //全局字典項
  MessageBox_title: "提示",
  MessageBox_confirmButtonText: "確定",
  MessageBox_cancelButtonText: "取消",
  MessageBox_areYouSure: "確定退出？",
  MessageBox_unRepair: "確定解除？",
  MessageBox_keepDebts: "是否要掛賬?",
  MessageBox_checkOutAdd: "是否加收房費?",
  MessageBox_checkOutAdd_select: "請選擇加收方式",
  MessageBox_checkOutAdd_action0: "加收半天",
  MessageBox_checkOutAdd_action1: "加收全天",
  MessageBox_checkOutAdd_action0_sure: "確定加收半天?",
  MessageBox_checkOutAdd_action1_sure: "確定加收全天?",
  MessageBox_checkIn: "確定辦理入住?",
  MessageBox_cancelOrder: "請輸入取消原因（可空）",
  MessageBox_delete_meeting: "確定刪除:",
  MessageBox_cancel: "確定取消?",
  MessageBox_cancelMeeting: "確定批量修改?",
  MessageBox_use: "確定核銷？",
  MessageBox_selectShiftTitle: '選擇班別',
  MessageBox_msg_selectShift: '請選擇班別',

  msg_delete_success: "刪除成功",
  msg_use_success: "使用成功",
  msg_update_success: "更新成功",
  msg_cancel_success: "取消成功",
  msg_modify_success: "修改成功",
  msg_checkin_success: "辦理入住成功",
  msg_addReceive_success: "加收成功",
  msg_keepDebts_success: "掛賬成功",
  msg_recognize_fail: "語音識別失敗：",
  msg_choose_room: "至少選擇一個房間",
  msg_choose_checkMethod: "請選擇支付方式",
  //book msg
  msg_error_code: "識別失敗！請正麵對準身份證，當照片清楚時再拍攝。",
  msg_rsvCompanyId4: "請填寫中介/旅行社",
  msg_rsvCompanyId3: "請填寫協議公司",
  msg_rsvCompanyId2: "請填寫會員卡信息",
  msg_rsvMan: "姓名不能為空",
  msg_rmtype: "房型不能為空",
  msg_idCode: "證件類型不能為空",
  msg_range: "入住/離店時間不能為空",
  msg_search: "請輸入搜索條件",
  msg_could_not_find: "沒有找到",
  msg_choose_reason: "請選擇原因",
  msg_no_more_room: "超過本次允許的房間數",
  msg_submitGear: "請先點擊排房或入住按鈕",
  msg_reserveBook: "請先選擇場地時間",
  msg_salesman: "銷售人不能為空",
  msg_phone: "聯系方式不能為空",
  msg_theme: "主題不能為空",
  msg_category: "宴會類型不能為空",
  msg_linkman: "聯系人不能為空",
  msg_cateringPlaceString: "場地列表不能為空",
  msg_beginDateString: "場地開始時間不能為空",
  msg_endDateString: "場地結束時間不能為空",
  msg_meetingBook_sta: "狀態不能為空",
  msg_meetingBook_update: "修改會議室成功",
  msg_meetingBook_Success: "預定會議室成功",
  msg_cancelMeeting: "取消會議室成功",
  msg_handleConfirmEnd: "會議結束日期要比開始日期晚。",
  msg_save_fail: "保存失敗",

  msg_nav: "本功能需要PMS版本:",
  msg_getDetail: "當前優惠券不可核銷",
  msg_getbarcode: "非可核銷優惠券類型",
  Toast_nomorethan5: "預警事件不能超過5個",
  Toast_nomorethan11: "您最多可以增加11個",
  Toast_selectcondition: "請選擇不同的指標!",
  Toast_pickDate: "起止天數相差不能超過5天",
  Toast_pickDate1: "結束天數必須大於開始天數",
  Toast_addNewTime: "預警時間最多三個",
  Toast_checkCondition: "請完善當前判斷條件",
  Toast_checkCondition1: "請完善當前判斷條件",
  Toast_checkCondition2: "數據上界必需大於數據下界",
  Toast_del_last: "無法刪除最後一個",
  Toast_save_rule: "請輸入事件名稱",
  Toast_save_rule1: "請輸入具體提前天數",
  Toast_save_rule_time: "請輸入預警時間",
  Toast_noticeContent: "請輸入提醒內容",
  Toast_save_success: "保存成功！",
  //導航 首頁
  index_refresh: "下拉刷新",
  index_homeData_title: "預計本日總營收",
  index_homeData_analy: "可售",
  index_homeData_analy_unit: "間",
  index_homeData_analysis: "過夜出租率",
  index_homeData_analysis_avg: "過夜均價",
  index_homeData_angle_allNum: "總房數",
  index_homeData_angle_allNum_unit: "間",
  index_homeData_angle_sorted: "已售房",
  index_homeData_angle_sorted_rate: '已售率',
  index_homeData_angle_sort: "可售房",
  index_homeData_angle_takeUp: "占用房",
  index_homeData_angle_maintenance: "維修房",
  index_homeData_angle_personalUse: "自用房",
  index_homeData_angle_free: "免費房",
  index_homeData_angle_lock: "鎖定房",

  index_homeData_angle_lock_oo: '大修',
  index_homeData_angle_lock_os: '小修',

  index_homeData_notarrRoom: "本日將到",
  index_homeData_isarrRoom: "本日已到",
  index_homeData_notdepRoom: "本日未離",
  index_homeData_isdepRoom: "本日已離",


  index_homeData_define: "指標定義",
  index_new_version: "版本更新說明",
  footNav_home: "首頁",
  footNav_info: "消息",
  footNav_discover: "發現",
  footNav_center: "我的",
  //moreFunction
  moreFunction_tip: "按住拖動調整排序",
  //login
  login_hotelCode: "酒店代碼",
  login_username: "用戶名",
  login_password: "請輸入密碼",
  login_login: "登錄",
  login_pleseRemember: "記住賬號密碼",
  login_saved_Password: "保存的密碼",
  login_hotelCode_Not_Empty: "請填寫酒店代碼",
  login_username_Not_Empty: "請填寫用戶名",
  login_password_Not_Empty: "請填寫密碼",
  login_only_code: "唯一碼",

  //serarch
  search_title: "切換酒店",
  search_placeholder: "酒店代碼/酒店部分名稱",
  search_often: "常用",
  search_city: "城市",
  search_brand: "品牌",
  search_area: "區域",
  search_hotel: "酒店",
  search_all: "所有",
  // fangT
  fangT_title: "房態",
  fangT_placeholder: "房號/姓名",
  fangT_category_name: "大小房",
  fangT_rmno: "房號",
  fangT_rmno_placeholder: "請輸入房號",
  fangT_staNew: "修改房態",
  fangT_rmnos: "房間號碼",
  fangT_rmnos_placeholder: "輸入房號（必填）",
  fangT_sta: "操作類型",
  fangT_beginDate: "開始日期",
  fangT_endDate: "結束日期",
  fangT_reasonCode: "選擇原因",
  fangT_remark_placeholder: "輸入備注（可空）",
  fangT_mutlSelectTitle: "已選擇 0 項",
  fangT_mutlSelectTitleText: "已選擇",
  fangT_mutlSelectTitUnit: "項",
  fangT_view: "查看",
  fangT_RoomStaI: "檢查",
  fangT_RoomStaR: "幹淨",
  fangT_RoomStaD: "臟房",
  fangT_RoomStaPU: "小修",
  fangT_reserveBook: "預訂",
  fangT_walkBook: "入住",
  fangT_RoomStaOOO: "維修",
  fangT_RoomStaOOS: "鎖定",
  fangT_unRepair: "解除",
  fangT_building: "樓棟",
  fangT_floor: "樓層",
  fangT_rmtype: "房型",
  fangT_feature: "特征",
  fangT_villadataV: "可用",
  fangT_villadataB: "大房",
  fangT_villadataS: "小房",

  // opera新增的
  fangT_sure_prev: '確定把 ',
  fangT_sure_clean: ' 的房態修改為幹凈嗎',
  fangT_sure_dirty: ' 的房態修改為臟房嗎',
  fangT_sure_inspected: ' 的房態修改為檢查嗎',
  fangT_sure_small_build: '查詢小房態時請先選擇樓棟',
  fangT_sure_small_build_most_before: '最多查詢 ',
  fangT_sure_small_build_most_after: ' 棟樓',
  fangT_sure_same_status: '不能同時選擇狀態不壹樣房間',
  fangT_sure_check_small: '查看小房態',
  fangT_sure_check_orderDetail: '查看訂單',

  //fangQ
  fangQ_title: "房情",
  fangQ_title1: "經營情況",
  fangQ_title2: "客房情況",
  fangQ_date: "日期",
  fangQ_takeup: "占用",
  fangQ_available: "可用",
  fangQ_maintenance: "維修",
  fangQ_average_price: "均價",
  fangQ_rents: "出租率",
  fangQ_action: "操作",
  fangQ_detail: "明細 >",
  fangQ_orderDetail_free: "空閑",
  fangQ_select_modal: '客房範圍',
  fangQ_select_title: '客房範圍選擇',
  fangQ_left_top_title: '樓號',
  fangQ_left_bottom_title: '大房類',
  fangQ_notice_text: '已選範圍',

  //fangXQ
  fangXQ_title: "房詳情",
  fangXQ_rmtype: "房型",
  fangXQ_total_num: "總房數",
  fangXQ_available: "可售",
  fangXQ_takeup: "占用",
  fangXQ_maintenance: "維修",
  fangXQ_toogle_type: "按大類",
  fangXQ_toogle_detail: "按明細",

  //book
  book_title: "房態詳情",
  book_active1: "散客",
  book_active2: "會員",
  book_active3: "協議公司",
  book_active4: "訂房中心",
  book_active5: "旅行社",
  book_name5: "旅行社",
  book_name4: "訂房中心",
  book_name3: "協議公司",
  book_name2: "會員卡",
  book_rsvMan: "姓名",
  book_rsvMan_placeholder: "請填寫預訂人姓名（必填）",
  book_mobile: "手機",
  book_mobile_placeholder: "請填寫11位手機號碼（可空）",
  book_idCode: "證件類型",

  book_idNo: "證件號碼",
  book_idNo_placeholder: "請填寫證件號碼(可空)",
  book_idNo_placeholder_required: "請填寫證件號碼(必填)",
  book_range: "入住/離店",
  book_rmnum: "房間數",
  book_rmno: "房間號",
  book_rmtype: "房型",
  book_ratecode: "房價碼",
  book_firstDayMoney: "首日房價",
  book_pkage: "包價",
  book_more_parmas: "更多參數",
  book_packup_parmas: "收起參數",
  book_rateSecret: "房價保密",
  book_rsvType: "預訂類型",
  book_market: "市場",
  book_src: "來源",
  book_channel: "渠道",
  book_cms_code: "傭金碼",
  book_payCode: "付款碼",
  book_salesman: "銷售員",
  book_salesman_placeholder: "請選擇銷售員",
  book_coMsg: "結賬提醒",
  book_otaRsvNo: "OTA預訂號",
  book_creditMan: "手工編號",
  book_specials: "特殊要求",
  book_amenities: "客房布置",
  book_origin_price: '原價',
  book_reason: '優惠理由',
  book_sync: '同步所有',
  book_select_type: '請選擇房型',
  book_reset_price_notice: '預定信息有變動，請重新設置自定義價格',
  book_define_title: '自定義房價',


  book_remark: "備注",
  book_amount: "總價",
  book_count: "費用明細",
  book_rmnum: "房數",
  book_total: "費用合計",
  book_reserveBook: "預定",
  book_walkBook: "入住",
  book_disRmType_des: "（房量不足）",
  book_disRmType_left: " -- 剩",
  book_disRmType_unit: "間",
  book_addRmType_btn: '新增房型',
  book_removeRmType_btn: '刪除房型',

  //fangTXQ
  fangTXQ_title: "登記單詳情",
  fangTXQ_rsvNo: "預訂單號",
  fangTXQ_sta: "狀態",
  fangTXQ_baseInfo: "基礎信息",
  fangTXQ_reserveBook: "預定",
  fangTXQ_name: "姓名",
  fangTXQ_mobile: "手機",
  fangTXQ_name2: "姓名2",
  fangTXQ_firstName: "姓/名",
  fangTXQ_rmno: "房號",
  fangTXQ_rmtype: "房類",
  fangTXQ_arr: "抵店",
  fangTXQ_dep: "離店",
  fangTXQ_memberNo: "卡號",
  fangTXQ_realRate: "房價",
  fangTXQ_idCode: "證件類型",
  fangTXQ_idNo: "證件號碼",
  fangTXQ_idNo_placeholder: "請輸入證件號碼",
  fangTXQ_companyName: "協議公司",
  fangTXQ_agentName: "旅行社",
  fangTXQ_sourceName: "訂房中心",
  fangTXQ_pmsTimesIn: '門店入住次數',
  fangTXQ_timesIn: '集團入住次數',
  fangTXQ_ratecode: "房價碼",
  fangTXQ_market_sales: "市場銷售",
  fangTXQ_salesman: "銷售",
  fangTXQ_rsvTypeName: "預訂類型",
  fangTXQ_market: "房價碼",
  fangTXQ_src: "來源",
  fangTXQ_cmscode: "傭金碼",
  fangTXQ_channel: "渠道",
  fangTXQ_payCode: "付款碼",
  fangTXQ_crsNo: "中央預訂號",
  fangTXQ_packagesDis: "包價",

  fangTXQ_other: "其他",
  fangTXQ_remark: "備注",
  fangTXQ_createUser: "創建人",
  fangTXQ_createDatetime: "創建時間",
  fangTXQ_modifyUser: "修改人",
  fangTXQ_modifyDatetime: "修改時間",
  fangTXQ_sepcials: "特別說明",

  fangTXQ_live_with: "同住",
  fangTXQ_none: "無",
  fangTXQ_al_room: "聯房",

  fangTXQ_bill: "賬單",
  fangTXQ_masterBase: "餘額",
  fangTXQ_credit: "信用",
  fangTXQ_othBalance: "餘額合計",
  fangTXQ_othCredit: "信用合計",
  fangTXQ_coMsg: "結賬提醒",
  fangTXQ_project: "項目",
  fangTXQ_time: "時間",
  fangTXQ_operator: "操作員",
  fangTXQ_amount: "金額",
  fangTXQ_cancelOrder: "取消訂單",
  fangTXQ_checkIn: "辦理入住",
  fangTXQ_addReceive1: "加收全天",
  fangTXQ_addReceive0: "加收半天",
  fangTXQ_keepDebts: "掛賬",
  fangTXQ_checkOut: "退房",

  fangTXQ_needMoney: "應收金額",
  fangTXQ_needMoney2: "實收金額",
  fangTXQ_checkMethod: "結賬類型",
  fangTXQ_payName: "付款人",
  fangTXQ_invoice_title: "發票擡頭",

  fangTXQ_date: "日期",
  fangTXQ_rate: "房價",
  fangTXQ_rmnum: "房間數",
  fangTXQ_total: "合計",

  fangTXQ_addReceiveMsg0: "是否加收半天?",
  fangTXQ_addReceiveMsg1: "是否加收全天?",

  fangTXQ_orderDisD: "鍾點",
  fangTXQ_orderDisG: "團隊",
  fangTXQ_amenities: "客房布置",
  fangTXQ_specials: "特殊要求",
  fangTXQ_creditMan: "手工編號",
  fangTXQ_otaRsvNo: "OTA訂單號",

  fangTXQ_changeRoomTitle: '選擇換房房間',
  fangTXQ_changeRoomNoRoom: '沒有查詢到可以更換的房間',
  fangTXQ_changeRoomSuccess: '換房成功',

  fangTXQ_scanPay_title:'掃碼支付',
  fangTXQ_bookName:'入住人',
  fangTXQ_bookTime:'入住時間',
  fangTXQ_savePictrue:'保存圖片',
  fangTXQ_forwardWechat:'轉發給微信好友',
  fangTXQ_generateQrCode:'生成二維碼',
  fangTXQ_transactionAmount:'交易金額',
  fangTXQ_pleaseTransactionAmount:'請輸入交易金額',
  fangTXQ_cannotTransactionAmount:'交易金額不能爲空',


  // 扫码支付
  scanPay_title: '掃碼支付',
  scanPay_save: '入賬',
  scanPay_money_placeholder: "請填寫本次入賬費用（必填）",
  scanPay_rmno: "房間號",
  scanPay_name: "姓名",
  scanPay_taCode: "代碼",
  scanPay_money: "費用",
  scanPay_taNo: "單號",
  scanPay_taRemark: "備注",
  scanPay_history: "支付記錄",
  scanPay_operator: "操作員",
  scanPay_date: "日期",
  scanPay_refund: '退款',
  scanPay_refund_check: '退款核對', //入賬核對
  scanPay_slide_notice: '左滑可進行退款核對和退款',
  scanPay_action_reAccount: "入賬核對",
  scanPay_action_reAccountSuccess: "入賬核對成功",
  scanPay_success: "退款成功",

  scanPay_refund_amount: '可退金額',
  scanPay_no_refund_amount: '可退金額为 0',
  scanPay_refund_amount_placeholder: '請輸入退款金額',
  scanPay_refund_error_money: '請輸入正確的退款金額',
  scanPay_refund_error_money2: '退款金額不能大於可退金額',

  // 添加同住人
  addLiveWith_title: '新增同住人',
  addLiveWith_no_name: '請填寫姓名',
  addLiveWith_no_sex: '請選擇性別',
  addLiveWith_no_vip: '請選擇VIP',
  addLiveWith_nation: '國籍',
  addLiveWith_language: '語言',
  addLiveWith_checkIn: '立即入住',
  addLiveWith_copyPackage: '復制包價',
  addLiveWith_same_rsvn_no: '相同預定號',
  addLiveWith_name: '姓名',
  addLiveWith_name_place: '請填寫同住人姓名（必填）',

  delayIn_Title: "續住",
  delayIn_newEndDate: "離店日期（新）",
  delayIn_EndDate: "離店日期",
  delayIn_days: "續住天數",
  delayIn_confirm: "確定續住到：",
  delayIn_success: "續住成功",

  //入賬
  incomeAccount_tilte: "入賬",
  incomeAccount_roomNo: "房間號",
  incomeAccount_name: "姓名",
  incomeAccount_code: "代碼",
  incomeAccount_fee: "費用",
  incomeAccount_fee_placehold: "請填寫本次入賬費用（必填）",
  incomeAccount_orderNo: "單號",
  incomeAccount_remark: "備注",
  incomeAccount_save: "入賬",
  incomeAccount_empty_feeCode: "請選擇費用代碼",
  incomeAccount_empty_money: "請填寫費用金額",
  incomeAccount_error_money: "請填寫正確金額",
  incomeAccount_confirm_money: "確定入賬金額：",
  incomeAccount_success: "入賬成功",

  incomeAccount_select_subAccount_pl: "選擇分賬戶",
  incomeAccount_select_subAccount_title: "分賬戶",
  incomeAccount_msg_select_subAccount: "請選擇分賬戶",
  incomeAccount_msg_ar_company: "請選擇簽單公司",
  incomeAccount_msg_ar_account: "請選擇簽單人",
  incomeAccount_msg_ar_select_company: "AR公司",
  incomeAccount_msg_ar_select_amount: "余額",
  incomeAccount_msg_ar_arno: "手工編號",
  incomeAccount_msg_ar_coding: "編碼",
  incomeAccount_msg_ar_avaliable_date: "有效期",
  incomeAccount_msg_ar_avaliable_date_center: "至",

  incomeAccount_msg_ar_no_date: '該公司不在有效期範圍內',
  incomeAccount_msg_ar_no_status: '該公司目前不可用',

  //更新訂單備注
  updateRemark_title: "追加備注",
  updateRemark_confirm: "確定追加備注信息?",
  updateRemark_notEmpty: "備注不能為空",

  //orderList
  orderList_title: "訂單列表",
  orderList_searchText_placeholder: "姓名/手機/登記單號",
  orderList_notArr: "本日將到",
  orderList_hasArr: "本日已到",
  orderList_allHasArr: "全部已到",
  orderList_notDep: "未離",
  orderList_hasDep: "已離",
  orderList_allReserve: "有效預訂",
  orderList_rsvNo: "訂單號",
  orderList_rsvClassF: "散客",
  orderList_rsvClassD: "鐘點",
  orderList_rsvClassG: "團隊",
  orderList_username: "姓名",
  orderList_mobile: "手機",
  orderList_arr: "到離",
  orderList_rmtype: "房類",
  orderList_realRate: " 房價",
  orderList_member_no: "卡號",
  orderList_member_crpName: "公司",
  orderList_category_name: "銷售員",
  orderList_showCategory: "[清空]",
  orderList_arr_S: "到離",
  orderList_tip: "僅作用於類別 “有效預訂”",
  orderList_dep_S: "離店起止日期",

  orderList_total: "共",
  orderList_rmnum: "房數",
  orderList_ordernum: "單",
  orderList_peoplenum: "人",


  //orderDetail
  orderDetail_title: "訂單詳情",
  orderDetail_crsNo: "訂單號",
  orderDetail_sta: "狀態",
  orderDetail_checkIn_info: "入住信息",
  orderDetail_rsvArrDate: "抵店",
  orderDetail_rsvDepDate: "離店",
  orderDetail_rmtypes: "房型",
  orderDetail_rmtypes_unit: "間",
  orderDetail_paiF: "排房",
  orderDetail_arr: "抵店",
  orderDetail_dep: "離店",
  orderDetail_pick_room: "選房",

  orderDetail_realRate: "房價",
  orderDetail_name: "姓名",
  orderDetail_idNo: "證件號",
  orderDetail_rsvNo: "房間號",
  orderDetail_sex: "性別",
  orderDetail_sex1: "男",
  orderDetail_sex2: "女",
  orderDetail_staI: "已入住",
  orderDetail_staO: "已離店",
  orderDetail_staS: "已掛賬",
  orderDetail_staX: "已取消",
  orderDetail_realRate: "房價",
  orderDetail_isSecretRate: "【保密】",
  orderDetail_totalmoney: "總房價",
  orderDetail_bookInfo: "總房價",
  orderDetail_bookName: "預訂人",
  orderDetail_memberNo: "卡號",
  orderDetail_mobile: "手機",
  orderDetail_mobile_placeholder: "手機（可空）",
  orderDetail_payment_info: "預收款信息",
  orderDetail_pay: "預收款",
  orderDetail_credit: "預授權",
  orderDetail_charge: "餘額",

  orderDetail_checkin: "排房/入住",
  orderDetail_guest_info: "住客信息",
  orderDetail_guest_name: "姓名",
  orderDetail_guest_name_placeholder: "請輸入姓名",
  orderDetail_search_room: "搜索本訂單房間",
  orderDetail_room: "房間",
  orderDetail_has_chosen: "已選擇",
  //repair
  repair_title: "房間詳情",
  repair_staS: "鎖定房",
  repair_staO: "維修房",
  repair_begin: "開始",
  repair_end: "結束",
  //meetingOrder
  meetingOrder_title: "會議訂單",
  meetingOrder_seachContent_placeholder: "主題/預定名稱/聯系人/電話",
  meetingOrder_all: "全部",
  meetingOrder_theme: "主題",
  meetingOrder_order: "預定",
  meetingOrder_fast: "快捷",
  meetingOrder_dateBegin: "開始時間",
  meetingOrder_dateEnd: "結束時間",
  meetingOrder_linkMan: "姓名",
  meetingOrder_phone: "聯系電話",
  meetingOrder_sort: "排序方式",

  meetingOrder_in_the_day: "當天",
  meetingOrder_today: "今天",
  meetingOrder_tomorrow: "明天",
  meetingOrder_tomorrow2: "後天",
  meetingOrder_orderdata1: "按時間",
  meetingOrder_orderdata2: "按場地",

  meetingOrder_staR: "不確定",
  meetingOrder_staI: "確定",
  meetingOrder_staX: "取消",
  meetingOrder_staD: "刪除",
  meetingOrder_staG: "擔保",
  meetingOrder_staS: "自用",
  meetingOrder_staO: "維修",
  //meetingBook
  meetingBook_title1: "預定會議室",
  meetingBook_title: "修改會議室",
  meetingBook_theme_placeholder: "請填寫會議主題",
  meetingBook_categoryCode: "宴會類型",
  meetingBook_linkman: "聯系人",
  meetingBook_linkman_placeholder: "請填寫聯系人",
  meetingBook_phone: "聯系方式",
  meetingBook_phone_placeholder: "請填寫聯系方式",
  meetingBook_board: "指示牌",
  meetingBook_board_placeholder: "請填寫指示牌（可空）",

  meetingBook_rsvName: "預訂名稱",
  meetingBook_booking: "預訂中",
  meetingBook_rsvName_placeholder: "請填寫預訂名稱（可空）",
  meetingBook_peopleNumber: "人數",
  meetingBook_peopleNumber_placeholder: "請填寫人數（可空）",
  meetingBook_tables: "桌數",
  meetingBook_tables_placeholder: "請填寫桌數（可空）",
  meetingBook_rate: "費用",
  meetingBook_rate_placeholder: "請填寫費用（可空）",
  meetingBook_resRate: "資源費用",
  meetingBook_resRate_placeholder: "請填寫資源費用（可空）",
  meetingBook_comRate: "綜合費用",
  meetingBook_comRate_placeholder: "請填寫綜合費用（可空）",

  meetingBook_agreement_unit: "協議單位",
  meetingBook_remark: "備注",
  meetingBook_not_support: "酒店不支持會議",

  meetingBook_meeting_room: "會議室",
  meetingBook_meeting_room_unit: "場",
  meetingBook_events_list: "場次列表",
  meetingBook_tip: "點擊日期修改可修改時間，僅限製當前場次範圍",
  //meetingCancel
  meetingCancel_title: "會議批量取消",
  //meetingEdit
  meetingEdit_title: "會議批量修改",
  meetingEdit_theme: "主題",
  meetingEdit_theme_placeholder: "如需修改填寫新的主題",
  meetingEdit_staCode: "狀態",
  meetingEdit_staCode_placeholder: "如需修改選擇新狀態",
  meetingEdit_board: "指示牌",
  meetingEdit_board_placeholder: "如需修改填寫新的指示牌",

  meetingEdit_categoryCode: "宴會類型",
  meetingEdit_categoryCode_placeholder: "如需修改選擇新宴會類型",
  meetingEdit_rsvName: "預定名稱",
  meetingEdit_rsvName_placeholder: "如需修改填寫新的預定名稱",

  meetingEdit_salesman: "銷售員",
  meetingEdit_salesman_placeholder: "如需修改選擇新銷售員",

  meetingEdit_linkman: "聯系人",
  meetingEdit_linkman_placeholder: "如需修改填寫新的聯系人",

  meetingEdit_phone: "聯系電話",
  meetingEdit_phone_placeholder: "如需修改填寫新的聯系電話",
  meetingEdit_must_select: "必需選擇一條",
  //會議詳情
  meetingDetail_title: "會議訂單詳情",
  meetingDetail_orderNo: "預訂單號",
  meetingDetail_totalFee: "總費用",
  meetingDetail_placeInfo: "場館信息",
  meetingDetail_catNo: "宴會編號",
  meetingDetail_categoryCode: "宴會類型",
  meetingDetail_theme: "主題",
  meetingDetail_sta: "狀態",
  meetingDetail_placeDes: "場地",
  meetingDetail_board: "指示牌",
  meetingDetail_remark: "備注",
  meetingDetail_orderInfo: "預訂信息",
  meetingDetail_rsvName: "預訂名稱",
  meetingDetail_tables: "桌數",
  meetingDetail_dateBegin: "開始時間",
  meetingDetail_dateEnd: "結束時間",
  meetingDetail_peopleNumber: "人數",
  meetingDetail_linkMan: "聯系人",
  meetingDetail_tel: "電話",
  meetingDetail_salesman: "銷售",
  meetingDetail_company: "協議單位",
  meetingDetail_rate: "費用",
  meetingDetail_comRate: "綜合費用",
  meetingDetail_other: "其他",
  meetingDetail_createDate: "創建時間",
  meetingDetail_modifyDate: "修改時間",
  meetingDetail_batModify: "批量修改",
  meetingDetail_batCancel: "批量取消",

  //cityState
  cityState_title: "同城房態",
  cityState_search_placeholder: "酒店名/代碼",

  //index_homeData_analysis: "",
  //導航 消息
  //導航 我的
  info_title: "消息",
  info_send_message: "發送消息",
  info_readStatusNull: "全部",
  info_readStatus0: "未讀",
  info_readStatus1: "已讀",
  //infoDetail
  infoDetail_title: "消息",
  infoDetail_eventName: "事件名稱",
  infoDetail_noticeContent: "提醒內容",
  infoDetail_hotelNames: "酒店名稱",
  infoDetail_dateCondition: "日期條件",
  infoDetail_checkTime: "檢查時段",
  infoDetail_quota: "檢查指標",
  infoDetail_quotaCondition: "指標條件",
  infoDetail_values: "實際數據",
  infoDetail_noticeDatetime: "運算時間",
  infoDetail_close: "知道了",


  // pushMessage 消息推送
  pushMessage_page_title: '消息',
  pushMessage_title: '標題',
  pushMessage_content: '內容',
  pushMessage_receiver: '消息接收人',
  pushMessage_receiver_placeholder: '請選擇消息接收人(最多可選20個人)',
  pushMessage_require_title: '請輸入消息標題',
  pushMessage_title_too_long: '消息標題太長，請不要超過40個字',
  pushMessage_require_content: '請輸入消息內容',
  pushMessage_require_receiver: '請選擇消息接收人',
  pushMessage_require_receiver_overmax: '最多可以選擇20位接收人',
  pushMessage_save: '發送',
  MessageBox_pushMessage_save: '確定發送',
  pushMessage_success: '發送成功',

  // pushMessageDetail
  pushMessageDetail_page_title: '消息詳情',
  pushMessageDetail_title: '標題',
  pushMessageDetail_content: '內容',
  pushMessageDetail_sendTime: '發送時間',
  pushMessageDetail_receive_title: '消息接收情況',
  pushMessageDetail_status_readed: '已讀',
  pushMessageDetail_status_no_redead: '未讀',

  //cateringOrder
  cateringOrder_title: "餐飲訂單",
  cateringOrder_search_placeholder: "預訂名稱/姓名/手機/訂單號",
  cateringOrder_accnt: "預訂單號",
  cateringOrder_linkMan: "姓名",
  cateringOrder_resName: "預訂名稱",
  cateringOrder_tablenoDes: "主桌號",
  cateringOrder_phone: "聯系電話",
  cateringOrder_gsts: "人數",
  cateringOrder_bizDate: "就餐時間",
  cateringOrder_shift: "班別",
  cateringOrder_pccode: "營業點",
  cateringOrder_beginDate: "開始日期",
  cateringOrder_endDate: "結束日期",

  cateringOrder_shift_1: "早班",
  cateringOrder_shift_2: "中班",
  cateringOrder_shift_3: "晚班",
  cateringOrder_shift_4: "夜班",
  cateringOrder_shift_R: "預定",
  cateringOrder_shift_N: "未到",
  cateringOrder_shift_C: "確認",
  cateringOrder_shift_I: "登記",
  cateringOrder_shift_X: "取消",

  //cateringDetail
  cateringDetail_title: "餐飲詳情",
  cateringDetail_venue_info: "場館信息",
  cateringDetail_hotelCode: "預訂酒店",
  cateringDetail_shiftDes: "預訂時間",
  cateringDetail_pccodeDes: "營業點",
  cateringDetail_type1Des: "餐單類別",
  cateringDetail_tablenoDes: "主桌號",
  cateringDetail_exttableno: "擴展桌號",
  cateringDetail_res_info: "預訂信息",
  cateringDetail_amount: "用餐標準",
  cateringDetail_standardType: "標準類型",
  cateringDetail_numb: "桌數",
  cateringDetail_beginTime: "開始時間",
  cateringDetail_modeDes: "優惠模式",
  cateringDetail_endTime: "結束時間",
  cateringDetail_pay: "預付金額",
  cateringDetail_payTypeDes: "付款方式",
  cateringDetail_info: "備注",
  cateringDetail_con_info: "聯系信息",
  cateringDetail_linkMan: "聯系人",
  cateringDetail_phone: "電話",
  cateringDetail_haccntName: "賓客信息",
  cateringDetail_love: "賓客喜好",
  cateringDetail_cusinfo: "協議單位",
  cateringDetail_cardNo: "會員卡號",
  cateringDetail_cardName: "會員名稱",
  cateringDetail_saleInfo: "銷售",
  cateringDetail_marketDes: "市場",
  cateringDetail_sourceDes: "來源",
  cateringDetail_cancel_confirm: "確定取消訂單嗎？",
  cateringDetail_cancel_success: "訂單取消成功",

  // 餐饮预订
  cateringCreate_title: '餐飲預訂',
  cateringCreate_workstation: '營業點',
  cateringCreate_peopleNumber: "人數",
  cateringCreate_peopleNumber_placeholder: '請填寫人數',
  cateringCreate_bookDate: '預訂日期',
  cateringCreate_bookTime: '預訂時間',
  cateringCreate_bookTime_placeholder: '請選擇預訂時間',
  cateringCreate_linkman: "聯系人",
  cateringCreate_linkman_placeholder: "請填寫聯系人",
  cateringCreate_phone: "聯系方式",
  cateringCreate_phone_placeholder: "請填寫聯系方式",
  cateringCreate_tableType: "桌位類型",
  cateringCreate_tableNo: "桌號",
  cateringCreate_notice_workstation: '請選擇營業點',
  cateringCreate_notice_bookDate: '請選擇預定日期',
  cateringCreate_notice_success: '預定成功',

  //shirtReport
  shirtReport_title: "交班報表",
  shirtReport_info: "繳款信息",
  shirtReport_bill_info: "入賬信息",
  shirtReport_all_class: "全部班級",
  shirtReport_all_user: "全部用戶",
  //eventinfo
  eventInfo_title: "事件編輯",
  eventInfo_descript: "事件名稱",
  eventInfo_descript_placeholder: "請輸入事件名稱",
  eventInfo_receiver: '預警接收人',
  eventInfo_receiver_placeholder: '請選擇預警接收人',

  addNewEvent_date_con: "日期條件",
  addNewEvent_date_con_placeholder: "請輸入事件名稱",
  eventInfo_today: "當天",
  eventInfo_days_advance: "提前天數",
  eventInfo_days_start: "天數開始",
  eventInfo_days_stop: "天數結束",
  eventInfo_timeListAnimation: "預警系統判斷 * 到 * 天之後的指標數據（按天）",
  eventInfo_pickerValue_label: "觸發時間",
  eventInfo_eventTimeInput_label: "請選擇時間",
  eventInfo_addEventTime: "+ 新增時間條件",
  eventInfo_conditions: " 判斷條件",
  eventInfo_quotaDescript: "指標",
  eventInfo_operation: "條件",
  eventInfo_valLeft: "數據下界",
  eventInfo_valRight: "條件",
  eventInfo_valRight_placeholder: "數據上界（必於大於下界）",
  eventInfo_val: "數值",
  eventInfo_val_placeholder: "條件數據",
  eventInfo_addNewConditions: "+ 新增判斷條件",
  eventInfo_tip: "提醒內容",
  eventInfo_checklistVal: "是否啟用",
  eventInfo_tipContent_placeholder: "請輸入提醒內容(必填)",
  //addNewEvent
  addNewEvent_title: "新建事件",

  //member
  member_title: "會員分析",
  member_time_type: "時間類型",
  member_time_type_day: "按天",
  member_time_type_month: "按月",
  member_time_trend: "會員趨勢",

  member_mroption: "發展方式",
  member_new_member: "新會員",
  member_pay: "充值",
  member_pay_detail: "[明細]",
  member_charge: "消費",
  member_card_type: "卡類",
  member_ship_card: "會員卡類",
  member_data_class: "數據分類",
  member_dataSort_buyCount: "會員發展數",
  member_dataSort_charge: "充值費用",
  member_dataSort_pay: "消費費用",
  member_growType_0: "全部",
  member_growType_1: "線上",
  member_growType_2: "線下",
  member_all_cardType: "全部卡類",
  member_trend: "全部卡類",
  //memberDetailPay
  memberDetailPay_title: "充值明細",
  memberDetailPay_payment: "支付方式",
  memberDetailPay_amount: "金額",
  memberDetailPay_total: "合計",
  //memberDetailCharge
  memberDetailCharge_title: "消費明細",
  memberDetailPay_category: "類別",
  //memberDetailCharge
  revenueCompare_title: "營收對比",
  revenueCompare_month: "月",

  revenueCompare_sequential: "環比",
  revenueCompare_compared: "同比",
  revenueCompare_rev_ttl: "總收入",
  revenueCompare_rev_rm: "房費收入",
  revenueCompare_rev_fb: "餐費收入",
  revenueCompare_rev_ot: "其他收入",
  revenueCompare_rm_avg: "平均房價",
  revenueCompare_rm_occ: "出租率",

  revenueCompare_rev_rmot: '客房其他',
  revenueCompare_rev_meet: '會議',
  revenueCompare_rev_sport: '康樂',
  revenueCompare_rev_ent: '娛樂',
  revenueCompare_rev_ex: '代收',

  revenueCompare_by_month: '按月',
  revenueCompare_by_day: '按日',
  revenueCompare_choose_date: '選擇日期',
  revenueCompare_table_date1: '日期壹',
  revenueCompare_table_date2: '日期二',
  revenueCompare_choose_get1: '營收壹',
  revenueCompare_choose_get2: '營收二',
  revenueCompare_time_dur1: '時間段壹',
  revenueCompare_time_dur2: '時間段二',

  revenueCompare_type_title1: '今年去年',
  revenueCompare_type_title2: '去年前年',
  revenueCompare_type_title3: '前年大前年',
  revenueCompare_type_title4: '大前年大大前年',
  revenueCompare_type_title_RT: '今年前年',
  revenueCompare_type_title_custom: '自定義年份',

  revenueCompare_type_lastyear1: '前年',
  revenueCompare_type_lastyear2: '大前年',
  revenueCompare_type_lastyear3: '大大前年',


  revenueCompare_message1: '時間段二的結束日期不能大於今天',
  revenueCompare_message2: '查詢的時間間隔不能大於31天',

  // revenueReportChart // 营收图表
  revenueReportChart_title: '營收大类图表',

  //revenueReport
  //revenueReport
  revenueReport_title: "營收情況",
  revenueReport_project: "營收情況",
  revenueReport_quantity: "筆數",
  revenueReport_daily: "日營收",
  revenueReport_month: "月累計",
  revenueReport_year: "年累計",
  revenueReport_nothing: "什麼都沒有，請檢查當日夜審情況",
  //cashierReport
  cashierReport_title: "收款情況",
  cashierReport_project: "項目",
  //payReport
  payReport_title: "結賬情況",
  payReport_title1: "收款合計",
  payReport_title2: "收入合計",
  //roomPrediectionReport
  roomPrediectionReport_title: "房類預測",
  roomPrediectionReport_title1: "收款合計",
  roomPrediectionReport_saled: "已售",
  //orderFromReport
  orderFromReport_title: "客源情況",
  orderFromReport_switchbtn_title: "市場",
  orderFromReport_switchbtn_title2: "渠道",
  orderFromReport_switchbtn_title3: "來源",
  orderFromReport_choose: "選擇指標",
  orderFromReport_rent: "出租數",
  orderFromReport_rm_avg: "平均房價",
  orderFromReport_rm_occ: "出租率",
  orderFromReport_total_charge: "總房費",
  orderFromReport_rev_rm: "房費",
  orderFromReport_chart_series_name: "訪問來源",


  RmtypeFloor_title: "房類樓層",
  RmtypeFloor_switchbtn_title: "房類",
  RmtypeFloor_switchbtn_title2: "樓層",
  RmtypeFloor_switchbtn_title3: "樓棟",
  RmtypeFloor_choose: "選擇指標",
  opera_index_detail_title: '經營數據',

  //indexDetail
  indexDetail_title: "排行榜",
  indexDetail_sort: "高到低",
  indexDetail_rentRate: "出租率",
  indexDetail_revenue: "總收入",
  indexDetail_roomrevenue: "房費收入",
  indexDetail_foodrevenue: "餐飲收入",
  indexDetail_avgPrice: "平均房價",
  indexDetail_revMem: "會員卡費收入",
  indexDetail_revEnt: "娛樂收入",
  indexDetail_revHrs: "鍾點房費收入",
  indexDetail_otherrevenue: "其它收入",
  //indexDesc
  indexDesc_title: "指標說明",
  indexDesc_total_revenue: "預計本日總營收",
  indexDesc_total_revenue_value: "預計房費收入(不含鍾點)+",
  indexDesc_total_revenue_value1: "餐飲實際收入+其它實際收入",
  indexDesc_available: "可售",
  indexDesc_available_value: "當日可售過夜房數",
  indexDesc_take_up_room: "占用房",
  indexDesc_take_up_room_value: "當前在住 - 預計離店 + 預計到達",
  indexDesc_take_up_room_value_normal: "當前在住-預計離店+預計到達-自用房-免費房",
  indexDesc_overnight_rate: "過夜出租率",
  indexDesc_overnight_rate_value: "占用房/總房數",
  indexDesc_night_average_value: "預計房費收入(不含鍾點)/占用房",
  indexDesc_night_average: "過夜均價",
  indexDesc_REVPAR_value: "過夜出租率 * 過夜均價",
  indexDesc_total_rooms: "總房數",
  indexDesc_total_rooms_value: "物理總房數（不含假房）",
  indexDesc_since_room: "自用房",
  indexDesc_since_room_value: "“市场”为“自用”的登记单",
  indexDesc_since_room_value1: "對應的房間，不計入占用房",
  indexDesc_free_room: "免費房",
  indexDesc_free_room_value: "“市場”為“免費”的登記單",
  indexDesc_free_room_value1: "對應的房間，不計入占用房",
  indexDesc_maintenance_room: "維修房",
  indexDesc_maintenance_room_value: "客房狀態為“維修”的房間，",
  indexDesc_maintenance_room_value1: "維修房不計入占用房",
  indexDesc_locked_room: "鎖定房",
  indexDesc_locked_room_value: "客房狀態為“鎖定”的房間，",
  indexDesc_locked_room_value1: "鎖定房計入可售房",

  index_homeData_notarrRoom_value: '本日將到的房間總數',
  index_homeData_isarrRoom_value: '本日已到的房間總數',
  index_homeData_notdepRoom_value: '本日未離的房間總數',
  index_homeData_isdepRoom_value: '本日已離的房間總數',


  indexDesc_chart_desc: "PS.餅圖隻是表示各類型占比，整圈度量不代表總房數",
  //version
  version_title: "版本信息",
  version_version: "版本號",
  version_tip1: "全新界麵風格，采用類支付寶App首頁的可定義功能按鈕。",
  version_tip2: "增加消息模塊，第一時間接收到有用的通知。",
  version_tip3: "增加餐飲、會議預訂查詢。",
  version_tip4: "增加事件預警、對酒店關鍵指標可預警提醒。",
  //cacheManger
  cacheManger_title: "緩存管理",
  cacheManger_clear: "清除",
  cacheManger_clearCloudAddress: "清除地址緩存",
  cacheManger_clearCloudParamCache: "清除參數緩存",
  cacheManger_clearCloudWithoutUserInfo: "清除除個人信息以外",
  cacheManger_clearAddress: "清除本機地址緩存",
  cacheManger_clearParamCache: "清除本機參數緩存",
  cacheManger_clearAllWithoutUserInfo: "清除本機除個人信息以外",
  //configeHotel
  configeHotel_title: "配置關注酒店",
  //couponUse
  couponUse_title: "卡券核銷",
  couponUse_workstation: "營業點",
  couponUse_TodaySum: "本日累計",
  couponUse_Hotel: "全店",
  couponUse_Unit: "條",
  couponUse_Num: "券號",
  couponUse_sta: "狀態",
  couponUse_P: "折",
  couponUse_Can_workstation: "適用營業點",
  couponUse_tip: "請先掃描優惠券",
  couponUse_need_workstation: "此優惠券需要指定營業點",
  couponUse_error_workstation: "當前營業點不能核銷",

  couponUse_couponName: "名稱",
  couponUse_couponCode: "代碼",
  couponUse_couponTyDes: "類別",
  couponUse_cardNo: "會員卡",
  couponUse_couponType: "麵值",
  couponUse_hotelDateSet: "適用日期",
  couponUse_validFromDate: "有效日期",
  couponUse_validToDate: "截止日期",
  couponUse_couponDes: "描述",
  couponUse_remark: "備注",
  couponUse_dis: "優惠券不可用",
  couponUse_getbarcode: "掃碼",
  couponUse_btnv: "核銷",
  couponUse_CouponUseSetting: "參數設置",
  couponUse_CouponUseHistory: "曆史查詢",

  couponUse_search_title: "核銷曆史",
  couponUse_search_user: "核銷人",
  couponUse_search_date: "核銷時間",
  couponUse_search_MemName: "姓名",

  //命名規則 路由+字段
  center_event_warning: "事件預警",
  center_feedback: "意見反饋",
  center_share_APP: "分享APP",
  center_cacheMange: "緩存管理",
  center_pushSend: "消息推送",
  center_version: "版本信息",
  center_licManage: "管理授權客戶端",
  center_setting: "參數設置",
  center_message: "將離開本應用前往第三方調查平台，是否繼續？",
  center_selfReportSetting: "自定義報表配置",
  center_thirdUrlSetting: "擴展程序配置",
  center_unBind:"解綁設備",
  center_unBind_confirm:"確定解綁設備嗎?",

  center_clear_all_cache_title: '清除所有緩存',
  center_clear_all_cache: '確定清除所有緩存嗎?',
  center_clear_all_cache_success: '緩存清除成功',

  //個人信息
  centerinfo_title: "個人信息",
  centerinfo_code: "用戶名",
  centerinfo_mac: "設備ID",
  centerinfo_version: "PMS版本",

  //事件預警
  eventWorm_title: "事件預警",
  eventWorm_descript: "事件名稱",
  eventWorm_conditions: "條件",
  eventWorm_notice_content: "提醒內容",
  eventWorm_day_conditions: "天數條件",
  eventWorm_today: "當天",
  eventWorm_advance: "提前",
  eventWorm_day: "天",
  eventWorm_triggering_time: "觸發時間",
  //版本號，版本信息 建議直接對應的if else寫死
  //授權客戶端
  licManage_title: "授權客戶端",
  licManage_hotelCode: "酒店名稱",
  licManage_limit: "限",
  licManage_client_number: "個客戶端",
  licManage_all_records: "共有記錄",
  licManage_records_unit: "條",
  licManage_prompt: "提示：左劃刪除記錄",
  //授權客戶端
  setting_title: "參數設置",
  setting_account_security: "賬號與安全",
  setting_select_shift: '班别設置',
  setting_message_notice: "新消息通知",
  setting_clean_localStorage: "清除本地緩存",
  settinge_device: "設備信息",
  setting_mobileOrder_url: '設置手機點餐連接地址',
  setting_sys_option: '系統參數設置',

  // 系统参数设置
  setting_sys_option_desc: '描述',
  setting_sys_option_key: '字段名',
  setting_sys_option_value: '值',

  //賬號和安全
  account_title: "賬號與安全",
  account_lockerTip: "手勢密碼",
  account_lockerTip_sta_1: "已設置",
  account_lockerTip_sta_2: "未啟用",
  account_lockerTip_label: "手勢密碼僅本機有效",
  account_tip: "如果遇到賬號非正常登錄，請及時修改密碼，並聯系管理員。",
  //accountLocker
  accountLocker_title: "手勢密碼",
  accountLocker_1: "啟用手勢密碼",
  accountLocker_2: "修改手勢密碼",
  accountLocker_tip:
    "手勢密碼僅本機有效，禁用手勢密碼後登錄密碼將不保存，退出賬號需要重新設置。",
  //anypay
  anypay_title: "任意付收銀台",
  anypay_des: "結賬金額",
  anypay_loading: "支付處理中...",
  anypay_action_search: "交易查詢",
  anypay_action_goRefund: "交易退款",
  anypay_action_reAccount: "入賬核對",
  anypay_scene: "掃碼支付",
  anypay_overtime: "支付超時",
  anypay_backspace: "退格",
  anypay_alipay_wechat: '支付寶/微信',

  msg_goRefund: "你沒有退款的權限",
  msg_payOrder: "支付金額不正確",
  msg_getbarcode: "非有效支付二維碼",
  msg_paySuccess: "支付成功",
  msg_keyDown: "請輸入支付金額",
  msg_than_price: "超過最多允許金額",
  msg_reAccount: "無上次訂單號記錄，無法核對入賬，如有異常請人工處理",
  MessageBox_closeQ: "確定客人已經放棄本次支付?",
  //anyrefundList
  anyrefundList_title: "退款",
  anyrefundList_id: "訂單ID",
  anyrefundList_feeName: "費用名稱",
  anyrefundList_feeCode: "費用代碼",
  anyrefundList_totalMoney: "總金額",
  anyrefundList_createDate: "支付時間",
  anyrefundList_taNo: "憑證號",
  anyrefundList_taWay: "付款方式",
  anyrefundList_feeName: "費用名稱",
  anyrefundList_payMoney: "支付金額",
  anyrefundList_status: "狀態",
  anyrefundList_detail: "詳情",
  anyrefundList_alter: "撤銷",
  anyrefundList_alter_success: "撤銷成功",
  anyrefundList_nothing: "什麼都沒有",
  anyrefundList_nothingTxt: "請輸入查詢條件查詢退款訂單",
  anyrefundList_nothingTxt1: "(僅能退營業日當天訂單）",
  anyrefundList_order_detail: "訂單詳情",
  anyrefundList_action_anpay: "收銀台",
  anyrefundList_action_RefundList: "交易查詢",
  anyrefundList_scene: "掃碼退款",
  msg_refundOrder_sta: "退款狀態為:",
  msg_checkOutRevoke: "賬單撤銷成功",
  msg_anyrefundList_search: "查詢內容不能為空",
  MessageBox_showAlter: "是否確定撤銷該訂單?",
  //賬號和安全
  anypaySearch_title: "交易查詢",
  anypaySearch_orderNumer_placeholder: "憑證號 / 訂單ID",

  //pushSend
  pushSend_title: "推送發送",
  pushSend_product: "目標系統",
  pushSend_product_placeholder: "目標系統(非空)",
  pushSend_hotelGroupCode: "集團代碼",
  pushSend_hotelCode: "酒店代碼",
  pushSend_loginName: "用戶登錄名",
  pushSend_push_title: "內容標題(非空)",
  pushSend_overview: "副標題",
  pushSend_content: "消息內容(非空)",
  pushSend_url: "鏈接地址",
  pushSend_save: "推送",
  msg_save1: "共推送",
  msg_save2: "條記錄",
  MessageBox_pushSend_save: "確定推送?",
  //memberSearch
  memberSearch_title: "會員搜索",
  memberSearch_searchType_placeholder: "條件類型",
  memberSearch_seachContent_placeholder: "搜索條件",
  memberSearch_name: "姓名",
  memberSearch_cardNo: "卡號",
  memberSearch_mobile: "手機",
  memberSearch_address: "地址",
  memberSearch_dis: "請輸入搜索條件",
  memberSearch_searchType_cardNo: "會員卡號",
  memberSearch_searchType_name: "會員姓名",
  memberSearch_searchType_mobile: "手機號碼",
  memberSearch_searchType_idNo: "證件號碼",
  memberSearch_searchType_email: "電子郵箱",
  msg_searchType: "請選擇搜索條件類型",
  msg_searchOption: "請輸入搜索條件",
  //memberDetail
  memberDetail_title: "會員詳情",
  memberDetail_cardNo: "主卡號",
  memberDetail_sta: "狀態",
  memberDetail_base_info: "基本信息",
  memberDetail_name: "姓名",
  memberDetail_sex: "性別",
  memberDetail_birth: "生日",
  memberDetail_isWechatMem: "是否微會員",
  memberDetail_accountBalance: "儲值餘額",
  memberDetail_pointBalance: "可用積分",
  memberDetail_accountTreatBalance: "贈送賬號餘額",
  memberDetail_idTypeDescript: "證件類型",
  memberDetail_idNo: "證件號碼",
  memberDetail_companyName: "協議公司",
  memberDetail_loginTime: "登錄時間",
  memberDetail_createDatetime: "注冊時間",
  memberDetail_rateCode: "房價碼",
  memberDetail_book: "預訂客房",
  memberDetail_contact_info: "聯系信息",
  memberDetail_mobile: "手機",
  memberDetail_email: "郵箱",
  memberDetail_phone: "電話",
  memberDetail_address: "地址",
  memberDetail_card_info: "會員卡信息",
  memberDetail_cardNo2: "卡號",
  memberDetail_cardTypeDescript: "會員計劃",
  memberDetail_cardLevelDescript: "等級",
  memberDetail_staDescript: "狀態",
  memberDetail_pointBalance: "積分餘額",
  memberDetail_accountBalance: "儲值餘額",
  memberDetail_checkOutTime: "延遲退房時間",
  memberDetail_validity: "有效期",
  //memberDetail_createDatetime: "注冊時間",
  //memberRegister
  memberRegister_title: "會員注冊",
  memberRegister_cardType: "會員計劃",
  memberRegister_cardLevel: "會員等級",
  memberRegister_taCode: "付款方式",
  memberRegister_taMoney: "付款金額",
  memberRegister_msg_no_taCode: "請選擇付款方式",
  memberRegister_name: "姓名",
  memberRegister_name_placeholder: "請填寫會員姓名（必填）",
  memberRegister_sex: "性別",
  memberRegister_sex_placeholder: "不可為空",
  memberRegister_mobile: "手機",
  memberRegister_mobile_placeholder: "請填寫11位手機號碼（必填）",
  memberRegister_password: "初始密碼",
  memberRegister_password_placeholder: "（必填）",
  memberRegister_email_placeholder: "請填寫Email地址（可空）",
  memberRegister_idType: "證件類型",
  memberRegister_idNo: "證件號碼",
  memberRegister_idNo_placeholder: "請填寫證件號碼(可空)",
  memberRegister_cardSrc: "來源",
  memberRegister_cardSrc_placeholder: "可空",
  memberRegister_salesman: "銷售員",
  memberRegister_salesman_placeholder: "可空",
  memberRegister_confirm: "注冊",
  msg_sfzRe: "識別失敗！請正麵對準身份證，當照片清楚時再拍攝。",
  msg_isEmpty_name: "姓名不能為空",
  msg_isEmpty_mobile: "手機不能為空",
  msg_isEmpty_password: "密碼不能為空",
  msg_book: "注冊成功",
  MessageBox_confirmB: "確定注冊?",
  //AccountIn
  AccountIn_title: "入賬",
  AccountIn_rmno: "房間號",
  AccountIn_name: "姓名",
  AccountIn_taCode: "代碼",
  AccountIn_clubCard: "會員卡",
  AccountIn_money: "費用",
  AccountIn_money_placeholder: "請填寫本次入賬費用（必填）",
  AccountIn_taNo: "單號",
  AccountIn_taRemark: "備注",
  AccountIn_save: "入賬",
  msg_isEmpty_taCode: "請選擇費用代碼",
  msg_isEmpty_cardNo: "請選擇會員卡",
  msg_isEmpty_money: "請填寫費用金額",
  msg_isEmpty_money2: "請填寫正確金額",
  MessageBox_AccountIn_save: "確定入賬金額：",
  MessageBox_AccountIn_remove_item: "確定要刪除該項嗎？",

  JJ_AccountIn_title: '賬務調整',
  JJ_AccountIn_reason: '理由',
  msg_need_reason: '請選擇理由',

  //selfReportSetting
  selfReportSetting_title: "自定報表設置",
  selfReportSetting_name: "報表名稱",
  selfReportSetting_name_placeholder: "建議2-6個字",
  selfReportSetting_code: "報表代碼",
  selfReportSetting_code_placeholder: "請填寫過程名稱（必填）",
  selfReportSetting_procName: "過程名稱",
  selfReportSetting_procName_placeholder: "過程名稱（必填）",
  selfReportSetting_type: "模板類型",
  selfReportSetting_type_tip2: "單日期酒店:過程為3參數<br>範圍日期酒店：過程為4參數",
  selfReportSetting_icon: "圖標",
  selfReportSetting_icon_placeholder: "選擇功能圖標",
  selfReportSetting_color: "顏色",
  selfReportSetting_color_placeholder: "選擇圖標顏色",
  selfReportSetting_data_src: " 數據來源",
  selfReportSetting_data_src_placeholder: " 不可為空",
  selfReportSetting_createDate: " 創建時間",
  selfReportSetting_deleteEv: " 刪除成功",
  //selfReportEdit
  selfReportEdit_title: "定義報表",
  selfReportEdit_column: "字段列名",
  selfReportEdit_column_c: "字段名",
  selfReportEdit_column_n: "顯示中文",
  selfReportEdit_column_w: "寬度%",
  selfReportEdit_column_addC: "添加",
  selfReportEdit_column_number: "序號",
  selfReportEdit_column_field: "字段名",
  selfReportEdit_column_chinese: "顯示中文",
  selfReportEdit_column_i: "縮進條件:列名,值 (可空)",
  selfReportEdit_column_i_tip: "例：type:1  表示本行記錄type例的值為1時顯示時會縮進顯示，其它條件不縮進",
  selfReportEdit_column_a: "對齊",
  selfReportEdit_column_a_tip: "可選：left,right,center",
  selfReportEdit_column_action: "操作",
  selfReportEdit_column_Index: "縮進",
  selfReportEdit_column_JSON: "以json方式查看",
  selfReportEdit_column_b: "著重",
  selfReportEdit_users: "權限鍵值",
  selfReportEdit_users_placeholder: "填寫PMS權限控製的鍵值",
  selfReportEdit_disOption: "顯示選項",
  selfReportEdit_ext2: "顯示擴展2",
  selfReportEdit_ext3: "顯示擴展3",
  selfReportEdit_listOrder: "排序值",
  selfReportEdit_listOrder_placeholder: "排序值(可空)",
  selfReportEdit_ext_placeholder: "可空",
  selfReportEdit_ishalt: "是否停用",
  selfReportEdit_ishalt_placeholder: "不可為空",
  selfReportEdit_remark: "備注",
  selfReportEdit_dataType_dateTable: "單日期酒店選擇表格",
  selfReportEdit_dataType_rangTable: "範圍日期酒店選擇報表",
  selfReportEdit_First_line_sum: "首行為合計",
  selfReportEdit_Auto_scroll: "滾動時自動鎖定標題",

  selfReportEdit_dataType_group: "集團端",
  selfReportEdit_dataType_pms: "門店庫（暫不支持）",
  selfReportEdit_dataType_member: "會員庫（暫不支持）",

  selfReportEdit_TF_F: "啟用",
  selfReportEdit_TF_T: "停用",

  // thirdUrlSetting
  thirdUrlSetting_title: '擴展程序配置',
  thirdUrlSetting_createDate: " 創建時間",

  // thirdUrlEdit
  thirdUrlSetting_code: '擴展代碼',
  thirdUrlSetting_code_placeholder: '請填寫擴展代碼',
  thirdUrlSetting_name: '擴展名稱',
  thirdUrlSetting_name_placeholder: '請填寫擴展名稱',
  thirdUrlSetting_url: '擴展地址',
  thirdUrlSetting_url_placeholder: '請填寫擴展地址',
  thirdUrl_msg_isEmpty_code: '擴展代碼不能為空',
  thirdUrl_msg_isEmpty_name: '擴展名稱不能為空',
  thirdUrl_msg_isEmpty_url: '擴展地址不能為空',

  msg_isEmpty_addColumn_c: "列名不能為空",
  msg_isEmpty_addColumn_n: "顯示中文不能為空",
  msg_isEmpty_addColumn_w: "寬度不能為空",
  msg_isEmpty_code: "代碼不能為空",
  msg_isEmpty_name: "名稱不能為空",
  msg_isEmpty_procName: "過程不能為空",
  msg_isEmpty_right: "權限鍵值不能為空",
  msg_isEmpty_columns: "字段列名不能為空",
  msg_only_group: "當前僅支持集團端取數據",
  //couponUseSetting
  couponUseSetting_title: "核銷設置",
  couponUseSetting_operating_point: "營業點",
  //賬號和安
  messagePush_title: "新消息設置",
  messagePush_receiveAlert: "接收預警消息",
  messagePush_receiveSystem: "接收系統消息",
  messagePush_startApp: "收到消息啟動APP",
  messagePush_vibration: "開啟震動",
  messagePush_voice: "語音",
  messagePush_tipBox: "當App運行時，你可以設置是否需要聲音或震動。",

  //賬號和安全
  device_title: "設備信息",
  device_name: "系統名稱",
  device_language: "系統語言",
  device_version: "系統版本",
  device_vendor: "系統供應商",
  device_model: "設備型號",
  device_vendor2: "生產廠商",
  device_mac: "設備ID",
  device_network: "網絡類型",
  device_screen: "分辨率",
  device_scale: "顯示比例",
  device_scale: "顯示比例",
  device_uuid: "設備ID",
  device_message: "清除後將重新登錄，是否清除?",

  //賬務代碼
  accountCode_Title: "營業項目",
  accountCode_SearchPlaceHold: "根據代碼或名稱搜索",
  accountCode_common: "常用",
  accountCode_fee: "消費",
  accountCode_pay: "付款",
  accountCode_preAuth: '預授權',
  accountCode_list: "列表",

  //日期酒店搜索
  dateHotel_SearchHotel: "請選擇酒店名稱",

  //日期控件
  controll_datepicker_to: "至",
  controll_datepicker_clear: "清除",
  controll_datepicker_selectEndDate: "請選擇結束時間",

  controll_datepik_no_next: "不能向後了",
  controll_datepik_no_pre: "不能向前了",

  //彈框搜索會員協議公司
  pop_search_isGroup: '是否集團搜索',
  pop_search_cardNo: '會員卡號',
  pop_search_mobile: '手機',
  pop_search_idNo: '證件',
  pop_search_cardType: '卡類',
  pop_search_rateCode: '房價碼',
  pop_search_No: '編號',
  pop_search_src: '來源碼',
  pop_search_market: '市場碼',
  pop_search_cms: '傭金碼',
  pop_search_saleman: '銷售員',
  pop_search_searchTile: '請輸入搜索條件',
  pop_search_mem_placeHolder: '搜索會員卡',
  pop_search_mem_SearchplaceHolder: '輸入會員卡號/手機號搜索',
  pop_search_A_placeHolder: '搜索旅行社',
  pop_search_A_SearchplaceHolder: '輸入旅行社名字搜索',
  pop_search_C_placeHolder: '搜索協議公司',
  pop_search_C_SearchplaceHolder: '輸入協議公司名字搜索',
  pop_search_S_placeHolder: '搜索訂房中心',
  pop_search_S_SearchplaceHolder: '輸入訂房中心名字搜索',

  //酒店搜索
  contrll_search_range: "選擇範圍",
  //控件topDatePick
  contrll_topDatePick_no_less_today: "不能查小於今天的",
  contrll_no_big_yesterday: "不能查大於昨天的",
  Update_LOG: "更新日誌",
  contrll_at_least: '請至少選擇壹家酒店',
  contrll_self_choice: '自選 ',
  contrll_num_hotel: ' 家酒店',
  contrll_only_hotel: '請選擇酒店',

  // discover 发现
  discover_title: '發現',
  discover_ad_icon: '廣告',

  // loginRecord 登录记录
  loginRecord_title: '登錄記錄',
  loginRecord_title_self: '本人的登錄記錄',
  loginRecord_title_all: '所有的登錄記錄',
  loginRecord_ip: '登錄IP',
  loginRecord_time: '登錄時間',

  // 快速预定会议
  meetingBookFast_page_title: '快捷會議預定',
  meetingBookFast_title: '請選擇會議室',
  meetingBookFast_select_time: '請選擇時間',
  meetingBookFast_time: '會議日期',
  meetingBookFast_time_part: '時間段',
  meetingBookFast_msg_selecte_part: '至少選擇壹個時間段',

  // reportViewRange 酒店营收报表范围
  reportViewRange_title: '酒店營收報表範圍',
  reportViewRange_project: '項目',
  reportViewRange_current_period: '本期',
  reportViewRange_corresponding_period: '同期',


  // memberContrast 会员对比
  memberContrast_title: '會員对比',
  memberContrast_current: '當期',
  memberContrast_lastyear: '去年同期',
  memberContrast_compare: '同比',


  // memberMoreHotelContrast 会员状况
  memberMoreHotelContrast_title: '會員狀況',
  memberMoreHotelContrast_mem_title: '會員卡',
  memberMoreHotelContrast_register_time: '註冊數',
  memberMoreHotelContrast_consume_time: '消費次數',
  memberMoreHotelContrast_consume_money: '消費金額',
  memberMoreHotelContrast_charge_money: '充值金額',

  // memberSingleContrast 会员指标
  memberSingleContrast_title: '會員指標',
  memberSingleContrast_quota: '指標',

  // memberPerformance 会员总体
  memberPerformance_title: '會員總體',
  memberPerformance_order: '排序',
  memberPerformance_roomIncome: '客房收入',
  memberPerformance_roomProportion: '客房收入占比',
  memberPerformance_roomCompared: '客房收入同比',

  memberPerformance_foodIncome: '餐飲收入',
  memberPerformance_foodProportion: '餐飲收入占比',
  memberPerformance_foodCompared: '餐飲收入同比',

  memberPerformance_otherIncome: '其他收入',
  memberPerformance_otherProportion: '其他收入占比',
  memberPerformance_otherCompared: '其他收入同比',

  // opera orderDetail
  operaOrderDetail_sure_checkout: '確定退房?',
  operaOrderDetail_sure_money: '金額必需大於0',
  operaOrderDetail_sure_account_in: '確定入賬?',
  operaOrderDetail_sure_not_end: '入住日期未到',
  operaOrderDetail_sure_checkIn: '確定入住?',
  operaOrderDetail_sure_cancel_reason: '請輸入取消訂單原因（可空）',
  operaOrderDetail_room: '房間',
  operaOrderDetail_room_choose: '已選擇',
  operaOrderDetail_room_over: '超過本次允許的房間數',
  operaOrderDetail_room_no: '請先選擇房間！',
  operaOrderDetail_room_special: '請先選擇具體的房間',
  operaOrderDetail_room_confirm1: '是否對房間',
  operaOrderDetail_room_confirm2: '進行排房',


  // searchHotel
  searchHotel_opera_notice: 'opera酒店不能加入多選',
  searchHotel_opera_notice2: '不能选择opera酒店',

  // operaOrder
  operaOrder_title: '房間步入',
  operaOrder_live_in_date: '入住日期',
  operaOrder_room: '房',
  operaOrder_bookinfo_name: '請填寫預訂人姓名（必填)',
  operaOrder_bookinfo_mobile: '請填寫預訂人手機（必填)',
  operaOrder_bookinfo_id: "身份證號",
  opera_search_history: "歷史搜索",

  // operaBook
  operaBook_checkin_time: '入住時間',
  operaBook_leave_time: '離店時間',
  operaBook_search_rmno: '搜索房價碼', // Rate Code


  // 锦江相关
  jj_door_card_info: '門卡信息',
  jj_room_no: '房號',
  jj_beginTime: '開始時間',
  jj_endTime: '結束時間',
  jj_doorCard_operate: '門卡操作',
  jj_addCard: '發新卡',
  jj_addCard_success: '門卡新增成功',
  jj_copyCard: '復制卡',
  jj_copyCard_success: '門卡復制成功',
  jj_readCard: '讀卡',
  jj_readCard_success: '門卡讀取成功',
  jj_cancelCard: '註銷卡',
  jj_cancelCard_success: '門卡註銷成功',
  jj_setting: '賬號配置',
  jj_token_error: '獲取錦江token失敗，請先配置錦江信息',
  jj_empty_card: '此卡為空卡',
  jj_cancel_text: '註銷',
  jj_id_card_read_success: '身份證讀取成功',
};



// WEBPACK FOOTER //
// ./src/locale/lang/zh_TW.js